<span class="signal-value" [ngClass]="{
    'signal-value-0' : signalValue === 0,
    'signal-value-1' : signalValue === 1,
    'signal-value-2' : signalValue === 2,
    'signal-value-3' : signalValue === 3,
    'signal-value-4' : signalValue === 4
}"></span>